import { UserRole } from '@features/authentication/types';

export const MANAGE_PREFIX = '/app/manage/';
export const MANAGE_PATH = '/app/manage';

interface ManageRolePolicy {
  /** Minimum URL segments after /app/manage/ for the route guard */
  minSegments: number;
  /** Segments after "Manage" to hide in breadcrumbs */
  breadcrumbSkip: number;
}

/**
 * Role-based manage route depth policy.
 *
 * The manage URL hierarchy is fixed:
 *   /app/manage/universities/:tenantId/institutes/:domainId/subjects/:subjectId/...
 *   segments:    [0]          [1]       [2]        [3]       [4]      [5]
 *
 * SYSTEM_ADMIN   - no entry (unrestricted access, no breadcrumb skipping)
 * UNIVERSITY_ADMIN - must be at universities/:tenantId or deeper; skip "universities" in breadcrumbs
 * FACULTY_ADMIN  - must be at .../institutes/:domainId or deeper; skip 3 breadcrumbs
 * PROFESSOR      - must be at .../subjects/:subjectId or deeper; skip 5 breadcrumbs
 */
export const MANAGE_ROLE_POLICY: Partial<Record<UserRole, ManageRolePolicy>> = {
  [UserRole.UNIVERSITY_ADMIN]: { minSegments: 2, breadcrumbSkip: 1 },
  [UserRole.FACULTY_ADMIN]: { minSegments: 4, breadcrumbSkip: 3 },
  [UserRole.PROFESSOR]: { minSegments: 6, breadcrumbSkip: 5 },
  [UserRole.COURSE_REPRESENTATIVE]: { minSegments: 6, breadcrumbSkip: 5 },
};
